<button mat-icon-button class="close-button " [mat-dialog-close]="true">
  <mat-icon class="close-icon">close</mat-icon>
</button>

<mat-dialog-content style="height: 100% !important; max-height: 100%;" (click)="clickOutsideCloseDialog($event)">
  <div class="container">
    <div class="row image-viewer">
      <pinch-zoom class="pinch-tag" disableZoomControl="disable">
        <img [src]="slides[currSlideIndex].image" id="carousel-img" class="carousel-img" alt="">
      </pinch-zoom>
      <span class="col-12 pinch-zoom-text-{{appName}}" *ngIf="(windowWidth <= 550)">Pinch To Zoom</span>
    </div>
    <div class="mt-4 row thumbnail-viewer">
      <div class="col-lg-12 col-xs-12 thumbnail-container">
        <img alt="" *ngFor="let slide of slides;" [ngClass]="this.slideActiveStatus[slide.index] ? 'active-thumbnail' : '' " [src]="slide.image"
          class="thumbnail-image thumbnail-image-{{appName}}" (click)="setActive(slide.index)">
      </div>
    </div>

  </div>

</mat-dialog-content>